import React from 'react';
import PropTypes from 'prop-types';
import { Todo } from '../Todo/Todo';

export const TodoList = ({
  todos,
  changeProcessTodo,
  deleteTodo,
  changeTodoItem,
}) => (
  <ul className="todo-list">
    {todos.map(todo => (
      <Todo
        key={todo.id}
        {...todo}
        changeProcessTodo={changeProcessTodo}
        deleteTodo={deleteTodo}
        changeTodoItem={changeTodoItem}
      />
    ))}
  </ul>
);

TodoList.propTypes = {
  changeProcessTodo: PropTypes.func.isRequired,
  deleteTodo: PropTypes.func.isRequired,
  changeTodoItem: PropTypes.func.isRequired,
  todos: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      completed: PropTypes.bool.isRequired,
      todos: PropTypes.string.isRequired,
    }),
  ).isRequired,
};
